import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography, makeStyles, CircularProgress, FormHelperText } from '@material-ui/core';
import React from 'react';
import { HomeContext } from '../../Home/HomeContext';
import { AuthContext } from '../../Authentication/AuthContext';
import { PageLocation } from '../../../shared/enum/PageLocation';
import InfluencerSpreadsheetService from '../../../Services/InfluencerService';
import { AxiosError, AxiosResponse } from 'axios';
import InfluencerService from '../../../Services/InfluencerService';
import { CompanyModel } from '../../../Models/CompanyModel';
import { InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';
import { StatusUpload } from '../../../shared/enum/StatusUpload';
import { format } from 'date-fns';
import { CompanyUploadResultInitial, CompanyUploadResultModel } from '../../../Models/CompanyUploadResultModel';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ptBR } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import { theme } from '../../../theme';
import { Autocomplete } from '@material-ui/lab';
import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';

type ErrosFormulario = Partial<Record<keyof CompanyModel, string>>;
export interface IHistoryClassificationProps {
    handlePageLocation: (location: PageLocation) => void;
}


function toBrasiliaISOString(date: Date) {
    const offsetMs = 3 * 60 * 60 * 1000;
    const brasiliaDate = new Date(date.getTime() - offsetMs);
    return brasiliaDate.toISOString().slice(0, 19); // 'YYYY-MM-DDTHH:mm:ss'
}
const useStyles = makeStyles((theme) => ({
    toolbar: {
        padding: '8px',
        backgroundColor: '#F0F1F1',
    },
    baritems: {
        width: '100%',
        paddingLeft: theme.spacing(3),
        maxWidth: '1152px',
    },
    itens: {
        width: '100%',
        color: 'primary',
    },
    loading: {
        minHeight: '80vh'
    },
    titleContainer: {
        marginBottom: theme.spacing(3)
    },
    root: {
        padding: theme.spacing(3),
        width: '100%',
        maxWidth: '1152px',
    },
    title: {
        margin: '20px 0px 32px'
    },
    tabs: {
        justifyContent: 'space-between',
        display: 'flex'
    },
    addNewButtonGrid: {
        justifyItems: 'center'
    },
    emptyTable: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1800px',
        padding: theme.spacing(0, 4)
    },
}));
export default function InfluencerSingleCompanySubmit() {
    const classes = useStyles();
    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const [news, setNews] = React.useState<CompanyModel>({} as CompanyModel);
    const clientEnable = homeContext.influencerClientEnable;
    const [status, setStatus] = React.useState<StatusUpload>(StatusUpload.INPUT);
    const [resultUpload, setResultUpload] = React.useState<CompanyUploadResultModel>(CompanyUploadResultInitial);
    const [filters, setFilters] = React.useState<InfluencersAuxiliarResponse>();
    const [loading, setLoading] = React.useState(false);
    const dataAtual = toBrasiliaISOString(new Date());


    const [erros, setErros] = React.useState<ErrosFormulario>({} as ErrosFormulario);
    const [showConfirmExit, setShowConfirmExit] = React.useState<boolean>(false);

    React.useEffect(() => {
        setLoading(true);
        if (clientEnable) {
            InfluencerService.getInfluencersBrandByClient(clientEnable.id_cliente)
                .then((res: AxiosResponse) => {
                    const username = authContext.login.user.username;


                    setFiltersData(res.data);
                    setNews(prev => ({
                        ...prev,
                        id_usuario: authContext.login.user.id,
                        dataRecebimento: dataAtual,
                        id_solicitante: username || '',
                        email: authContext.login.user.email || '',
                    }));
                    // setLoading(false);
                })
                .catch((error: AxiosError) => { setLoading(false); homeContext.showError('', error); });

            const userId = authContext.login.user.id;
            InfluencerService.getInfluencersResponsavelByUser(userId)
                .then((res: AxiosResponse) => {
                    setNews(prev => ({
                        ...prev,
                        responsavelReputacao: res.data.responsavel_reputacao[0]?.descricao,
                    }));
                    setLoading(false);
                })
                .catch((error: AxiosError) => { setLoading(false); homeContext.showError('', error); });
        }
    }, []);

    const setFiltersData = (data: InfluencersAuxiliarResponse) => {
        setFilters(data);
    };

    const handleChange = (prop: keyof CompanyModel) => (event: React.ChangeEvent<HTMLInputElement>) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        setNews({ ...news, [prop]: event.target.value });
    };


    const handleChangeDate = (prop: keyof CompanyModel) =>
        (date: Date | null) => {
            if (date) {
                setNews(prevNews => ({
                    ...prevNews,
                    [prop]: toBrasiliaISOString(date),
                }));
            }
        };

    const handleChangeSelect = (prop: keyof CompanyModel) =>
        (event: React.ChangeEvent<{ value: unknown }>) => {
            const value = event.target.value;
            // Se for o campo divulgacaoParceria e valor "Não" (0, '0', false, 'false'), limpa canais
            if (prop === 'divulgacaoParceria' && (value === 0 || value === '0' || value === false || value === 'false')) {
                setNews({ ...news, [prop]: value, canais: [] });
            } else {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                setNews({ ...news, [prop]: value });
            }
        };



    async function uploadCompany(clearAfterSuccess = false) {
        const errosValidacao = validarCampos();

        if (Object.keys(errosValidacao).length > 0) {
            setErros(errosValidacao);
            return; // impede o envio
        }

        setErros({} as ErrosFormulario);

        const clientId = clientEnable?.id_cliente;
        setResultUpload(CompanyUploadResultInitial);
        setLoading(true);

        if (clientId) {
            try {
                const updatedNews = { ...news, clientId };

                setNews(updatedNews);

                if (updatedNews.clientId && updatedNews.id_usuario) {
                    await InfluencerSpreadsheetService.postCompanyDetachedICE(
                        authContext.login.user.id,
                        updatedNews
                    );
                    homeContext.showSuccess('Solicitação enviada com sucesso. O prazo para retorno da análise é de 5 dias úteis. Caso seu pedido tenha urgência, entre em contato com o time de comunicação no canal do Slack #fale-com-reputação-gb');

                    if (clearAfterSuccess) {
                        clearInputs();
                    }
                }
            } catch (error) {
                setLoading(false);
                homeContext.showError('Erro ao Salvar o Evento/ Empresa.');
            } finally {
                setLoading(false);
            }
        }

    }

    const validarCampos = (): ErrosFormulario => {
        const novosErros: ErrosFormulario = {};

        const camposObrigatorios: (keyof CompanyModel)[] = [
            'area',
            'marca',
            'vp',
            'nome',
            'siteEmpresa',
            'tipoRelacionamento',
            'objetivo',
            'parceiraGB',
            'abrangencia',
            'periodoAcao',
            'periodoAcaoFim',
        ];

        camposObrigatorios.forEach((campo) => {
            const valor = news[campo];
            if (typeof valor === 'string' && !valor.trim()) {
                novosErros[campo] = 'Campo obrigatório.';
            } else if (valor === null || valor === undefined) {
                novosErros[campo] = 'Campo obrigatório.';
            }
        });

        // Validações condicionais
        if (news.divulgacaoParceria === undefined || news.divulgacaoParceria === null || news.divulgacaoParceria === '') {
            novosErros.divulgacaoParceria = 'Campo obrigatório.';
        }

        if (news.divulgacaoParceria) {
            if (!Array.isArray(news.canais) || news.canais.length === 0) {
                novosErros.canais = 'Campo obrigatório.';
            }
        }

        return novosErros;
    };


    const clearInputs = () => {
        setNews({
            ['id_usuario']: authContext.login.user.id,
            ['dataRecebimento']: dataAtual,
            ['id_solicitante']: news.id_solicitante,
            ['responsavelReputacao']: news.responsavelReputacao,
            ['email']: authContext.login.user.email || '',
        } as CompanyModel);
    };

    const hasDataFilled = () => {
        // Verifica se há dados preenchidos nos campos principais
        return (
            (news.area && news.area.trim() !== '') ||
            (news.marca && news.marca.trim() !== '') ||
            (news.vp && news.vp.trim() !== '') ||
            (news.nome && news.nome.trim() !== '') ||
            (news.siteEmpresa && news.siteEmpresa.trim() !== '') ||
            (news.tipoRelacionamento && news.tipoRelacionamento !== null && news.tipoRelacionamento !== undefined) ||
            (news.objetivo && news.objetivo.trim() !== '') ||
            (news.parceiraGB !== null && news.parceiraGB !== undefined) ||
            (news.abrangencia && news.abrangencia.trim() !== '') ||
            (news.periodoAcao && news.periodoAcao !== null) ||
            (news.periodoAcaoFim && news.periodoAcaoFim !== null) ||
            (news.observacoes && news.observacoes.trim() !== '') ||
            (news.divulgacaoParceria !== null && news.divulgacaoParceria !== undefined) ||
            (news.canais && Array.isArray(news.canais) && news.canais.length > 0)
        );
    };

    const handleGoToHome = () => {
        if (hasDataFilled()) {
            setShowConfirmExit(true);
        } else {
            homeContext.setPageLocation(PageLocation.INFLUENCER_HOME);
        }
    };

    const saveInputs = () => {
        return (
            <Grid
                container
                justifyContent="flex-end"
                alignItems="center"
                spacing={3}
            >
                <Grid
                    item xs={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => uploadCompany(true)}
                        size="large"
                        fullWidth>
                        {'Enviar'}
                    </Button>
                </Grid>
            </Grid>
        );
    };


    const inputTitleAndSubtitle = () => {
        return (
            <Grid
                container
                spacing={1}
                className={classes.titleContainer}
            >
                <Grid
                    item
                    xs={12}
                >
                    <Typography variant="h4">
                        Solicitação de Análise de Empresas, Eventos e Patrocínios
                    </Typography>
                </Grid>
                {/* <Grid
                    item
                    xs={12}
                >
                    <Typography variant="body1">
                        Para incluir um novo perfil, insira os dados solicitados abaixo
                    </Typography>
                </Grid> */}
            </Grid>
        );
    };

    const inputData = () => {
        const dataAtualFormatada = format(new Date(), 'dd/MM/yyyy');

        return (
            <Grid item xs={4}>
                <TextField
                    id="news-date"
                    label="Data"
                    value={dataAtualFormatada}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
            </Grid>
        );
    };
    const inputPeriodoAção = () => {
        return (
            <Grid item xs={8}>
                <Grid container spacing={4}>
                    <Grid item xs={6}>
                        <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                            <DatePicker
                                id="periodo-acao-comeco"
                                variant="inline"
                                value={news.periodoAcao ?? null}
                                inputVariant="outlined"
                                label="Início do Período da Ação"
                                minDate={new Date(0)}
                                clearable
                                emptyLabel=''
                                onChange={handleChangeDate('periodoAcao')}
                                format="dd/MM/yyyy"
                                className={classes.itens}
                                required error={!!erros.periodoAcao}
                            />
                            {erros.periodoAcao && (
                                <FormHelperText>Campo obrigatório.</FormHelperText>
                            )}
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={6}>
                        <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                            <DatePicker
                                id="periodo-acao-fim"
                                variant="inline"
                                value={news.periodoAcaoFim ?? null}
                                inputVariant="outlined"
                                label="Fim do Período da Ação"
                                minDate={news.periodoAcao ?? new Date(0)}
                                clearable
                                emptyLabel=''
                                onChange={handleChangeDate('periodoAcaoFim')}
                                format="dd/MM/yyyy"
                                className={classes.itens}
                                required error={!!erros.periodoAcaoFim}
                            />
                            {erros.periodoAcaoFim && (
                                <FormHelperText>Campo obrigatório.</FormHelperText>
                            )}
                        </MuiPickersUtilsProvider>
                    </Grid>
                </Grid>
            </Grid>
        );
    };


    const inputNome = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="nome"
                        value={news.nome || ''}
                        onChange={handleChange('nome')}
                        label="Nome da empresa/evento"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens}
                        required
                        error={!!erros.nome}
                    />
                    {erros.nome && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };


    const inputSiteEmpresa = () => {
        return (
            <>
                <Grid item xs={8}>
                    <TextField
                        id="siteEmpresa"
                        value={news.siteEmpresa || ''}
                        onChange={handleChange('siteEmpresa')}
                        label="Site da empresa/evento"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens}
                        required error={!!erros.siteEmpresa}
                    />
                    {erros.siteEmpresa && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };
    const inputSolicitante = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="solicitante"
                        value={news.id_solicitante || ''}
                        label="Solicitante da Marca"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };

    const inputResponsavelReputacao = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="responsavelReputacao"
                        value={news.responsavelReputacao ?? ''}
                        // onChange={handleChangeSelect('responsavelReputacao')}
                        label="Responsável Reputação"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };
    const inputEmail = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="Email"
                        value={news.email || ''}
                        // onChange={handleChange('Email')}
                        label="Email"
                        InputProps={{
                            readOnly: true,
                        }}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };

    const inputObservacoes = () => {
        return (
            <>
                <Grid item xs={12}>
                    <TextField
                        id="observacaoes"
                        value={news.observacoes || ''}
                        onChange={handleChange('observacoes')}
                        label="Observações"
                        variant="outlined"
                        multiline
                        minRows={3}
                        maxRows={3}
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };
    const inputObjetivo = () => {
        return (
            <>
                <Grid item xs={12}>
                    <TextField
                        id="objetivo"
                        value={news.objetivo || ''}
                        onChange={handleChange('objetivo')}
                        label="Objetivo"
                        variant="outlined"
                        multiline
                        minRows={3}
                        maxRows={3}
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} required error={!!erros.objetivo}
                    />
                    {erros.objetivo && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };


    const selectMarca = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.marca}
                >
                    <Autocomplete
                        id="marca-autocomplete"
                        options={filters?.marcas ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.marcas?.find(m => m.descricao === news.marca) || null}
                        onChange={(_, newValue) => {
                            setNews(prev => ({
                                ...prev,
                                marca: newValue ? newValue.descricao : ''
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Marca"
                                variant="outlined"
                                error={!!erros.marca}
                                required
                            />
                        )}
                    />
                    {erros.marca && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };


    const selectArea = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.area}
                >
                    <Autocomplete
                        id="area-autocomplete"
                        options={filters?.area ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.area?.find(a => a.descricao === news.area) || null}
                        onChange={(_, newValue) => {
                            setNews(prev => ({
                                ...prev,
                                area: newValue ? newValue.descricao : ''
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Área"
                                variant="outlined"
                                error={!!erros.area}
                                required
                            />
                        )}
                    />
                    {erros.area && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectVp = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.vp}
                >
                    <Autocomplete
                        id="vp-autocomplete"
                        options={filters?.vp ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.vp?.find(v => v.descricao === news.vp) || null}
                        onChange={(_, newValue) => {
                            setNews(prev => ({
                                ...prev,
                                vp: newValue ? newValue.descricao : ''
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="VP"
                                variant="outlined"
                                error={!!erros.vp}
                                required
                            />
                        )}
                    />
                    {erros.vp && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };


    const selectAbrangencia = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.abrangencia}
                >
                    <Autocomplete
                        id="abrangencia-autocomplete"
                        options={filters?.abrangencia ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.abrangencia?.find(a => a.descricao === news.abrangencia) || null}
                        onChange={(_, newValue) => {
                            setNews(prev => ({
                                ...prev,
                                abrangencia: newValue ? newValue.descricao : ''
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Abrangência"
                                variant="outlined"
                                error={!!erros.abrangencia}
                                required
                            />
                        )}
                    />
                    {erros.abrangencia && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectCanais = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.canais}
                >
                    <Autocomplete
                        multiple
                        id="canais-autocomplete"
                        options={filters?.canais ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.canais?.filter((c) => Array.isArray(news.canais) && news.canais.includes(c.descricao)) || []}
                        onChange={(_, newValue) => {
                            setNews(prev => ({
                                ...prev,
                                canais: newValue.map((c) => c.descricao).filter(Boolean),
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Canais de divulgação"
                                variant="outlined"
                                error={!!erros.canais}
                                required
                            />
                        )}
                        disableCloseOnSelect
                    />
                    {erros.canais && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };



    const selectParceiraGB = () => {
        return (
            <>
                <Grid item xs={4}>
                    <FormControl
                        variant="outlined"
                        fullWidth
                        required error={!!erros.parceiraGB}
                    >
                        <InputLabel id="submit-select" style={{ color: 'black' }}>
                            Já foi ou é uma parceira GB?
                        </InputLabel>
                        <Select
                            labelId="submit-select"
                            id="submit-select"
                            label="Já foi ou é uma parceira GB?"
                            value={news.parceiraGB ?? ''}
                            onChange={handleChangeSelect('parceiraGB')}
                        >
                            <MenuItem value="">Selecione</MenuItem>
                            <MenuItem value={1}>Sim</MenuItem>
                            <MenuItem value={0}>Não</MenuItem>
                        </Select>
                        {erros.parceiraGB && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </FormControl>
                </Grid>

                {news.parceiraGB == 1 && (
                    <Grid item xs={8}>
                        <TextField
                            label="Descreva o histórico com o GB"
                            variant="outlined"
                            fullWidth
                            value={news.parceiraGBContext || ''}
                            onChange={handleChange('parceiraGBContext')}
                            required error={!news.parceiraGBContext || news.parceiraGBContext.trim() === ''}
                        />
                        {news.parceiraGBContext && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </Grid>
                )}
            </>
        );
    };

    const selectTipoRelacionamento = () => {
        const outrosItem = filters?.tipo_relacionamento?.find(item => item.descricao?.toLowerCase() === 'outro');
        const outrosId = outrosItem?.id_aux;
        return (
            <>
                <Grid item xs={4}>
                    <FormControl
                        variant="outlined"
                        fullWidth
                        required
                        error={!!erros.tipoRelacionamento}
                    >
                        <Autocomplete
                            id="tipo-relacionamento-autocomplete"
                            options={filters?.tipo_relacionamento ?? []}
                            getOptionLabel={(option) => option.descricao || ''}
                            value={filters?.tipo_relacionamento?.find(t => t.id_aux === news.tipoRelacionamento) || null}
                            onChange={(_, newValue) => {
                                setNews(prev => ({
                                    ...prev,
                                    tipoRelacionamento: newValue && typeof newValue.id_aux === 'number' ? newValue.id_aux : 0,
                                }));
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Tipo de relacionamento/patrocínio"
                                    variant="outlined"
                                    error={!!erros.tipoRelacionamento}
                                    required
                                />
                            )}
                        />
                        {erros.tipoRelacionamento && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </FormControl>
                </Grid>

                {news.tipoRelacionamento == outrosId && (
                    <Grid item xs={8}>
                        <TextField
                            label="Contexto do relacionamento"
                            variant="outlined"
                            fullWidth
                            value={news.tipoRelacionamentoContext || ''}
                            onChange={handleChange('tipoRelacionamentoContext')}
                            required error={!news?.tipoRelacionamentoContext || news.tipoRelacionamentoContext.trim() === ''}
                        />
                        {news.tipoRelacionamento && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </Grid>
                )}
            </>
        );
    };


    const selectDivulgacaoParceria = () => {
        return (
            <>
                <Grid item xs={4}>
                    <FormControl
                        variant="outlined"
                        style={{ width: '100%' }}
                        required error={!!erros.divulgacaoParceria}
                    >
                        <InputLabel id="submit-select" style={{ color: 'black' }}>Haverá divulgação sobre a parceria?</InputLabel>
                        <Select
                            labelId="submit-select"
                            id="submit-select"
                            value={news.divulgacaoParceria ?? ''}
                            label="Haverá divulgação sobre a parceria?"
                            onChange={handleChangeSelect('divulgacaoParceria')}
                            style={{
                                outline: 'none',
                                borderBottom: 'none',
                            }}
                        >
                            <MenuItem value="">Selecione</MenuItem>
                            <MenuItem value={1}>Sim</MenuItem>
                            <MenuItem value={0}>Não</MenuItem>
                        </Select>
                        {erros.divulgacaoParceria && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
            </>
        );
    };


    const AccordionProfileData = () => {
        return (
            <Grid>
                <Grid container spacing={4} >
                    {inputSolicitante()}
                    {inputEmail()}
                    {inputData()}
                    {selectArea()}
                    {selectMarca()}
                    {selectVp()}
                    {inputNome()}
                    {inputSiteEmpresa()}
                    {selectTipoRelacionamento()}
                    {inputPeriodoAção()}
                    {inputObjetivo()}
                    {selectParceiraGB()}
                    {selectDivulgacaoParceria()}
                    {Number(news.divulgacaoParceria) == 1 && selectCanais()}
                    {selectAbrangencia()}
                    {inputObservacoes()}
                </Grid>
            </Grid>
        );
    };

    return (
        <>
            {!loading &&
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid container className={classes.toolbar} justifyContent="center"
                        alignItems="center">
                        <Grid
                            item
                            className={classes.baritems}
                            direction="column"
                        >
                            <Button
                                variant="text"
                                onClick={handleGoToHome}
                                style={{
                                    textTransform: 'initial',
                                    color: theme.palette.primary.main,
                                    padding: '8px 0px',
                                    fontSize: '14px'
                                }}
                            >
                                ← Voltar para a página inicial
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        className={classes.root}
                        direction="column"
                    >
                        <Grid
                            container
                            direction="row"
                            className={classes.root}
                            spacing={4}
                            alignItems="center"
                        >
                            {inputTitleAndSubtitle()}
                        </Grid>
                        <Grid container alignItems="center" spacing={3}>
                            <Grid item xs={12}>{AccordionProfileData()}</Grid>
                            <Grid item xs={12}>{saveInputs()}</Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
            {loading && <Grid container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.loading}>
                <CircularProgress color="primary" size="124px" />
            </Grid>}
            <BasicConfirmDialog
                title="Sair sem salvar?"
                description="Ao sair sem salvar, você perderá todos os dados de solicitação já preenchidos."
                handleFirstButton={() => homeContext.setPageLocation(PageLocation.INFLUENCER_HOME)}
                handleSecondButton={() => setShowConfirmExit(false)}
                textFirstButton="SAIR"
                textSecondButton="Permanecer na página"
                cssProperties={{
                    maxWidth: '550px'
                }}
                open={showConfirmExit} />
        </>
    );
}